export const gpaRoutesData1 = [
    {
        name: 'CSE',
        to: '/gpa1/cse1',
        expansion: 'Computer Science and Engineering'
    },
    {
        name: 'IT',
        to: '/gpa1/it1',
        expansion: 'Information Technology'
    },
    {
        name: 'AIML',
        to: '/gpa1/aiml1',
        expansion: 'Artificial Intelligence And Machine Learning'
    },
    {
        name: 'ECE',
        to: '/gpa1/ece1',
        expansion: 'Electronics and Communication Engineering'
    },
    {
        name: 'EEE',
        to: '/gpa1/eee1',
        expansion: 'Electrical and Electronics Engineering'
    },
    {
        name: 'MECH',
        to: '/gpa1/mech1',
        expansion: 'Mechanical Engineering'
    },
    {
        name: 'CIVIL',
        to: '/gpa1/civil1',
        expansion: 'Civil Engineering'
    },
    {
        name: 'BME',
        to: '/gpa1/auto1',
        expansion: 'Bio Medical Engineering'
    },
    // adding 7 new deparments
    {
        name: 'FT',
        to: '/gpa1/ft1',
        expansion: 'Fashion Technology'
    },
    {
        name: 'MCT',
        to: '/gpa1/mct1',
        expansion: 'Mechatronics Engineering'
    },
    {
        name: 'CSD',
        to: '/gpa1/csd1',
        expansion: 'Computer Science and Design'
    },
    {
        name: 'ADS',
        to: '/gpa1/ads1',
        expansion: 'Artificial Intelligence and Data Science'
    },
    {
        name: 'EFE',
        to: '/gpa1/ecce1',
        expansion: 'Electrical and Computer Engineering'
    },
    {
        name: 'EXE',
        to: '/gpa1/eece1',
        expansion: 'Electronics and Computer Engineering'
    },
        {
        name: 'CSB',
        to: '/gpa1/csb1',
        expansion: 'Computer Science and Business Intelligence'
    },
        {
        name: 'CSECS',
        to: '/gpa1/csecs1',
        expansion: 'Computer Science and Engineering (Cyber Security)'
    },
        {
        name: 'FSE',
        to: '/gpa1/fse1',
        expansion: 'Safety and Fire Engineering'
    },
    {
        name: 'VLSI',
        to: '/gpa1/vlsi1',
        expansion: 'Electronics Engineering (VLSI Design and Tech)'
    },
]

